import React, { useEffect, useState } from 'react';
import { CgArrowTopRight } from "react-icons/cg";
import { Link, useParams } from 'react-router-dom';
import config from '../config';
import AOS from "aos";
import fp2Content from '../JSONData/featuredProperties2.json';
import propertiesData from '../JSONData/featuredVideo.json'; // Import your properties JSON
// src/assets/videos/index.js
import LasOlas1 from '../assets/videos/LasOlas1.mp4';
import Chimeneas from '../assets/videos/Chimeneas-updated.mp4';

import PropertyImg from '../assets/images/Rectangle22.png';

import heroDesktopBanner from "../assets/images/home-hero-banner.jpg"
const videos = {
    "LasOlas1.mp4": LasOlas1,
    "Chimeneas-updated.mp4": Chimeneas,
};

const FeaturedPropertiesVideos = ({ customclasses, data }) => {
    const [properties, setProperties] = useState([]);
    const { lang } = useParams();
    const labels = (fp2Content && fp2Content[lang]) ? fp2Content[lang] : fp2Content.en;

    useEffect(() => {
        AOS.init({});
        AOS.refresh();
        if (propertiesData && propertiesData[lang]) {
            setProperties(propertiesData[lang]);
        } else if (propertiesData && propertiesData.en) {
            setProperties(propertiesData.en);
        } else if (Array.isArray(propertiesData)) {
            setProperties(propertiesData);
        }
    }, [lang]);

    const getProjectUrl = (slug) => {
        return lang ? `/${lang}/project/${slug}` : `/project/${slug}`;
    };

    return (
        <>
            <div className={`featured-property-section ${customclasses}`}>
                <div className='container'>

                    <div className='grid-blocks d-flex flex-wrap sm-flex-column row-gap-50 d-row-gap-80 d-col-gap-70 d-gap-50 featured-properties'>
                        {data === '1' ? <>

                            {properties[2] ?
                                <div className='grid-block d-pt-130'>
                                    <div className='featured-property-item layout-1 w-100' data-aos="fade-up" data-aos-delay="100" data-aos-duration="1000">
                                        <Link to='#'>
                                            <div className='image-block position-relative overlay d-flex align-end justify-start'>
                                                {properties[2]?.featuredVideo.endsWith(".mp4") ? (<video
                                                    src={videos[properties[2]?.featuredVideo]}
                                                    className='cover position-absolute top-0 start-0'
                                                    autoPlay
                                                    loop
                                                    muted
                                                    playsInline
                                                />) : (
                                                    <img src={PropertyImg} alt={properties[2]?.title} />
                                                )}
                                                <div className="summary-block pb-30 text-left pe-20 ps-30 d-pe-0 d-ps-50 position-relative">
                                                    <div className='h6 mb-15'>{properties[2]?.location}</div>
                                                    <div className='h2 fw-300 mb-15'>{properties[2]?.title}</div>
                                                    <Link to='#' className='button gap-10'>{labels.viewRenderingVideo}<CgArrowTopRight /></Link>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </div> : <></>}
                           </> : <></>}
                        {data === '2' ? <>
                         {properties[0] ?
                                <div className='grid-block d-pt-130'>
                                    <div className='featured-property-item layout-1 w-100' data-aos="fade-up" data-aos-delay="100" data-aos-duration="1000">
                                        <Link to='#'>
                                            <div className='image-block position-relative overlay d-flex align-end justify-start'>
                                                {properties[0]?.featuredVideo.endsWith(".mp4") ? (<video
                                                    src={videos[properties[0]?.featuredVideo]}
                                                    className='cover position-absolute top-0 start-0'
                                                    autoPlay
                                                    loop
                                                    muted
                                                    playsInline
                                                />) : (
                                                    <img src={PropertyImg} alt={properties[0]?.title} />
                                                )}
                                                <div className="summary-block pb-30 text-left pe-20 ps-30 d-pe-0 d-ps-50 position-relative">
                                                    <div className='h6 mb-15'>{properties[0]?.location}</div>
                                                    <div className='h2 fw-300 mb-15'>{properties[0]?.title}</div>
                                                    <Link to='#' className='button gap-10'>{labels.viewRenderingVideo}<CgArrowTopRight /></Link>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </div> : <></>}
                               {properties[1] ?
                                <div className='grid-block'>
                                    <div className='featured-property-item layout-2 w-100' data-aos="fade-up" data-aos-delay="100" data-aos-duration="1000">
                                        <Link to='#'>
                                            <div className='image-block position-relative overlay d-flex align-end justify-start'>
                                                
                                                    <img src={PropertyImg} alt={properties[1]?.title} />
                                                
                                            </div>
                                        </Link>
                                        <div className="summary-block text-left position-relative pt-30 d-pt-40">
                                            <div className='h6 mb-15'>{properties[1]?.location}
                                                
                                            </div>
                                            <div className='h2 fw-300 mb-15'>{properties[1]?.title}</div>
                                            <Link to='#' className='button gap-10'>{labels.viewRenderingVideo}<CgArrowTopRight /></Link>

                                        </div>
                                    </div>
                                </div> : <></>}
                                
                            </> : <>
                        </>}
                    </div>

                </div>
            </div>
        </>
    )
}

export default FeaturedPropertiesVideos